import Entity from 'txp-data/lib/schema/Entity';
import LogNames from 'txp-data/lib/schema/telemetry/LogNames';
import { TxpDatapoint } from 'txp-data';
import { logCalendarUsage } from 'owa-shared-analytics';
import TxpDataPointNames from '../../store/schema/telemetry/TxpDataPointNames';

export default function logOwaDateError(e: Error, entity: Entity) {
    const txpDataPoint: TxpDatapoint = {
        e: e.message,
        [LogNames.entityNamesFlag]: entity.entityType.toString(),
    };

    logCalendarUsage(
        TxpDataPointNames.TxpOwaDataError,
        txpDataPoint,
        entity.originalEmailInternetMessageId
    );
}
